import React from "react";
import Reveal from "./Reveal";
import { ArrowRight } from "lucide-react";

/**
 * Proof of Momentum - Compressed Teaser.
 *
 * Replaces the format-card-with-four-sub-cards layout until real
 * authentic-momentum case studies are ready to publish. Documents
 * the documentation format in a single short paragraph and links
 * to /voices for real reflections that already exist.
 *
 * When real case study entries land, restore the fuller
 * ProofOfMomentum.jsx layout. This compressed version is intended
 * to honor the principle "do not display placeholder outcomes in
 * a way that could look like real client results" without losing
 * the section's place in the homepage flow entirely.
 */
const ProofOfMomentumTeaser = () => (
  <section
    id="proof-of-momentum"
    data-testid="proof-of-momentum-section"
    className="relative py-16 md:py-20 border-t border-gold/10"
  >
    <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
      <Reveal>
        <p className="text-[11px] tracking-[0.5em] uppercase text-gold mb-5">
          Proof of Momentum
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl text-themed leading-tight tracking-tight font-light max-w-2xl mx-auto">
          When clarity becomes{" "}
          <span className="italic gold-gradient-text">movement.</span>
        </h2>
        <p className="mt-6 text-white/85 leading-relaxed">
          This space is being reserved for real reflections, reader responses, and lived examples as the work reaches more people. Each entry will follow a clean four-part format:{" "}
          <span className="text-gold/90">Before → Shift → Structure → Result</span>.
        </p>
        <a
          href="/voices"
          data-testid="proof-of-momentum-voices-link"
          className="btn-ghost-gold mt-8 inline-flex items-center gap-2"
        >
          Read Existing Reflections <ArrowRight size={13} />
        </a>
        <p className="mt-6 text-[12px] tracking-[0.18em] uppercase text-gold/70">
          <a
            href="/voices#add-your-words"
            data-testid="proof-of-momentum-reflection-invite"
            className="hover:text-gold transition-colors"
          >
            If the work has helped you name something, you can leave a reflection.
          </a>
        </p>
      </Reveal>
    </div>
  </section>
);

export default ProofOfMomentumTeaser;
